// 채팅방, 연락처에 대한 더미리스트 (기능 구현상으로 채팅방 추가, 연락처 추가 불가능)
export const dummyContactList = [
  {
    name: "이현진",
    introduction: "좋은 하루!",
  },
  {
    name: "정인영",
    introduction: "CEOS 프론트엔드",
  },
  {
    name: "김종완",
    introduction: "CEOS 백엔드",
  },
  {
    name: "나서강",
    introduction: "서강대학교 학생",
  },
  {
    name: "나오스",
    introduction: "CEOS 디자인",
  },
];

export const dummyChatList = ["이현진", "김종완"];
